import type { RfqStatus } from "@/lib/rfq/types";
import { useRfqLabels } from "@/lib/rfq/labels";

const STYLES: Record<RfqStatus, string> = {
  draft: "bg-gray-100 text-gray-600 ring-gray-200",
  inquiring: "bg-blue-50 text-blue-600 ring-blue-200",
  comparing: "bg-indigo-50 text-indigo-600 ring-indigo-200",
  pendingReview: "bg-amber-50 text-amber-600 ring-amber-200",
  awarded: "bg-emerald-50 text-emerald-600 ring-emerald-200",
  voided: "bg-red-50 text-red-600 ring-red-200",
};

function RfqStatusBadge({
  status,
  className = "",
}: {
  status: RfqStatus;
  className?: string;
}) {
  const { status: statusLabel } = useRfqLabels();

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${STYLES[status]} ${className}`}
    >
      {statusLabel(status)}
    </span>
  );
}

export default RfqStatusBadge;
